// src/components/Navbar.js
import React from "react";
import { Bell } from "lucide-react";
import "./navbar.css";

const Navbar = ({
  title = "Dashboard",
  subtitle = "Welcome back, Abhinav",
  userName = "Abhinav Kumar",
  userMembership = "Premium Member",
  profileImage = null, // Optional prop if you have an image later
}) => {
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "A";
  };

  return (
    <nav className="wc-navbar-container">
      {/* Left Section - Title */}
      <div className="wc-navbar-left">
        <h1 className="wc-navbar-title">{title}</h1>
        <p className="wc-navbar-subtitle">{subtitle}</p>
      </div>

      {/* Right Section - Bell & Profile */}
      <div className="wc-navbar-right">
        {/* Bell Icon */}
        <button className="wc-navbar-bell" aria-label="Notifications">
          <Bell size={20} />
          <span className="wc-navbar-bell_badge"></span>
        </button>

        {/* Profile Section */}
        <div className="wc-navbar-profile">
          {/* Circular Avatar Logic */}
          <div className="wc-navbar-profile_avatar">
            {profileImage ? (
              <img src={profileImage} alt="Profile" />
            ) : (
              <span>{getInitial(userName)}</span>
            )}
          </div>

          <div className="wc-navbar-profile_info">
            <span className="wc-navbar-profile_name">{userName}</span>
            <span className="wc-navbar-profile_membership">
              {userMembership}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
